module.exports = __webpack_public_path__ + "index_pc/img/head_photo.aa2cfd7b.svg";